import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconPhoneTopPunchHoleCenter: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPhoneTopPunchHoleCenter"><Path d="M3.5 20.5V6.5C3.5 4.84315 4.84315 3.5 6.5 3.5H17.5C19.1569 3.5 20.5 4.84315 20.5 6.5V20.5" stroke="currentColor" strokeLinecap="square"/><Circle cx="12" cy="6" r="1" fill="currentColor"/></CentralIconBase>;
});

export default IconPhoneTopPunchHoleCenter;
